import { LoaderCircle } from 'lucide-react';
import { CSSProperties } from 'react';

import { cn } from './cn';

export const Spinner = ({
  className,
  label = 'Loading',
  style,
}: {
  className?: string;
  label?: string;
  style?: CSSProperties;
}) => (
  <span role="status" className="inline-flex items-center" style={style}>
    <LoaderCircle aria-hidden="true" className={cn('size-4 animate-spin motion-reduce:animate-none', className)} />
    <span className="sr-only">{label}</span>
  </span>
);
